/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dragHelper = _interopRequireDefault(require("../../../packages/drag-helper"));
var emptyFn = function emptyFn() {};
var _default = function _default(_ref) {
  var constrainTo = _ref.constrainTo,
    region = _ref.region;
  var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var event = arguments.length > 2 ? arguments[2] : undefined;
  var _onDrag = cfg.onDrag || emptyFn;
  var _onDrop = cfg.onDrop || emptyFn;
  (0, _dragHelper.default)(event, {
    constrainTo: constrainTo,
    region: region,
    onDrag: function onDrag(event, config) {
      event.preventDefault();
      _onDrag({
        left: config.diff.left || 0,
        top: config.diff.top || 0
      }, event);
    },
    onDrop: function onDrop(event, config) {
      _onDrop(config.diff);
    }
  });
};
exports.default = _default;